var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "20 59 160 82.258",
    width: 200,
    height: 200,
    viewBox: "20 59 160 82.258",
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#comp-l15bf9n61 svg [data-color=\"1\"] {fill: #2F2E2E;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "svgcid-egflyn-2cnkin"
  }, "404 Cacti in a desert") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "svgcid-egflyn-2cnkin"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.553 75.892l5.86-2.73a2.18 2.18 0 011.976.07l1.05.584a.33.33 0 00.347-.018l2.54-1.768a2.156 2.156 0 011.678-.346c.589.12 1.089.466 1.408.975l.308.49a.329.329 0 00.512.054l1.427-1.46a2.17 2.17 0 011.988-.615 2.171 2.171 0 011.594 1.338l.093.237a.329.329 0 00.488.152l.426-.286a2.169 2.169 0 012.888.417l2.41 2.906H89.553zm27.987.467a.327.327 0 00-.045-.349l-2.855-3.443a2.822 2.822 0 00-3.758-.543l-.091.061a2.818 2.818 0 00-2.014-1.599 2.815 2.815 0 00-2.587.798l-1.136 1.163-.086-.137a2.807 2.807 0 00-1.832-1.269 2.803 2.803 0 00-2.184.451l-2.373 1.651-.872-.484a2.836 2.836 0 00-2.571-.092l-7.201 3.355a.328.328 0 00.139.625h29.169a.327.327 0 00.297-.188z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.825 60.128c.216-.3.553-.472.923-.472h.006c.373.002.71.178.925.483l1.271 1.799a.328.328 0 00.458.078l1.284-.918a1.138 1.138 0 011.336.009l2.941 2.156h-11.404l2.26-3.134zm-2.9 3.79h13.045a.328.328 0 00.194-.592l-3.748-2.75a1.792 1.792 0 00-2.105-.011l-1.016.725-1.08-1.53a1.774 1.774 0 00-1.456-.76h-.01c-.584 0-1.113.272-1.455.745l-2.636 3.653a.327.327 0 00.267.519z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.815 140.31v.249h2.92v-.328h-2.92v.079z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.99 140.56h5.959v-.329h-5.959v.329z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.135 140.56h5.959v-.329h-5.959v.329z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.677 140.56h2.979v-.329h-2.979v.329z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.274 140.56h5.705v-.329h-5.705v.329z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.47 139.314l.978-2.102-.596-.276-.971 2.088-.506-1.911-.634.168.52 1.962-2.104-2.347-.488.438 3.046 3.398 2.948-2.292-.403-.518-1.79 1.392z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.084 139.52l.622-2.574-.638-.155-.56 2.321-.664-1.552-.604.258.726 1.695-1.835-1.427-.402.518 2.936 2.285 1.776-1.823-.47-.458-.887.912z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.286 123.658c-.27 2.212-.734 4.14-1.388 5.788-.655 1.648-1.546 2.956-2.674 3.926-1.128.97-2.527 1.455-4.197 1.455-1.716 0-3.125-.484-4.23-1.455-1.107-.97-1.987-2.278-2.64-3.926-.655-1.647-1.117-3.576-1.388-5.788a57.936 57.936 0 01-.406-7.04c0-2.481.135-4.816.406-7.006.271-2.188.733-4.117 1.388-5.787.653-1.67 1.533-2.99 2.64-3.96 1.105-.971 2.514-1.456 4.23-1.456 1.67 0 3.07.485 4.197 1.456 1.128.97 2.02 2.29 2.674 3.96.654 1.67 1.117 3.599 1.388 5.787.271 2.19.406 4.525.406 7.006 0 2.482-.135 4.829-.406 7.04m7.48 1.354c.428-2.887.643-5.686.643-8.394 0-2.707-.215-5.505-.644-8.394-.429-2.886-1.24-5.54-2.436-7.953-1.196-2.414-2.867-4.4-5.01-5.957-2.143-1.557-4.907-2.336-8.292-2.336s-6.149.779-8.292 2.336-3.814 3.543-5.009 5.957c-1.196 2.414-2.008 5.067-2.437 7.953a57.141 57.141 0 00-.643 8.394c0 2.708.214 5.507.643 8.394.43 2.888 1.241 5.54 2.437 7.954 1.195 2.414 2.866 4.4 5.01 5.957a11.156 11.156 0 002.523 1.359l.804.277c1.474.46 3.124.699 4.964.699 1.841 0 3.49-.24 4.964-.7l.926-.327c.87-.348 1.675-.78 2.402-1.308 2.143-1.557 3.814-3.543 5.01-5.957 1.195-2.414 2.007-5.066 2.436-7.954",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.174 66.644a1.616 1.616 0 012.521.114l1.52 2.079c.052.072.132.12.22.131a.32.32 0 00.247-.066l.893-.702a1.617 1.617 0 012.076.063l1.577 1.402a.329.329 0 00.374.043l1.18-.635a1.607 1.607 0 011.419-.058l4.064 1.784H61.514l3.66-4.155zm-4.386 4.811h22.039a.328.328 0 00.132-.628l-5.494-2.412a2.26 2.26 0 00-1.993.08l-.98.528-1.406-1.25a2.27 2.27 0 00-2.916-.089l-.626.492-1.32-1.804a2.258 2.258 0 00-1.732-.93 2.26 2.26 0 00-1.81.768l-4.14 4.701a.329.329 0 00.246.544z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.434 140.56h3.278v-.329h-3.278v.329z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.61 140.56h5.958v-.329H48.61v.329z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.548 140.56h5.959v-.329h-5.959v.329z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.813 90.538h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.813 94.5h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.813 98.462h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.813 102.425h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.813 106.386h.184v-1.919h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.52 89.334h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.52 93.295h.184v-1.919h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.52 97.258h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.52 101.22h.184V99.3h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.52 105.182h.184v-1.919h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.52 109.145h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.391 110.35h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.757 82.613h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.757 86.576h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.757 90.538h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.757 94.5h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.757 98.462h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.757 102.425h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.757 106.386h.184v-1.919h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.757 110.35h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.464 81.409h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.464 85.372h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.464 89.334h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.464 93.295h.184v-1.919h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.464 97.258h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.464 101.22h.184V99.3h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.464 105.182h.184v-1.919h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.464 109.145h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.334 82.613h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.334 86.576h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.334 90.538h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.334 94.5h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.334 98.462h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.334 102.425h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.334 106.386h.184v-1.919h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.334 110.35h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.042 81.409h.183v-1.92h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.042 85.372h.183v-1.92h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.042 89.334h.183v-1.92h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.042 93.295h.183v-1.919h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.042 97.258h.183v-1.92h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.042 101.22h.183V99.3h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.042 105.182h.183v-1.919h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.042 109.145h.183v-1.92h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.912 82.613h.183v-1.92h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.912 86.576h.183v-1.92h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.912 90.538h.183v-1.92h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.912 94.5h.183v-1.92h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.912 98.462h.183v-1.92h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.912 102.425h.183v-1.92h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.912 106.386h.183v-1.919h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.912 110.35h.183v-1.92h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.773 109.145h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.643 110.35h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.099 112.947h.183v-1.919h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.309 112.947h.184v-1.919h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.886 112.947h.184v-1.919h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.757 114.151h.184v-1.919h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.757 118.114h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.757 122.076h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.757 126.038h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.757 130h.184v-1.918h-.184V130z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.757 133.963h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.757 137.925h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.464 112.947h.184v-1.919h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.464 116.91h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.464 120.871h.184v-1.919h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.464 124.835h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.464 128.796h.184v-1.919h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.464 132.758h.184v-1.918h-.184v1.918z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.464 136.72h.184v-1.918h-.184v1.918z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.334 114.151h.184v-1.919h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.334 118.114h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.334 122.076h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.334 126.038h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.334 130h.184v-1.918h-.184V130z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.334 133.963h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.334 137.925h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.042 112.947h.183v-1.919h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.042 116.91h.183v-1.92h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.042 120.871h.183v-1.919h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.042 124.835h.183v-1.92h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.042 128.796h.183v-1.919h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.042 132.758h.183v-1.918h-.183v1.918z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.042 136.72h.183v-1.918h-.183v1.918z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.912 114.151h.183v-1.919h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.912 118.114h.183v-1.92h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.912 122.076h.183v-1.92h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.912 126.038h.183v-1.92h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.912 130h.183v-1.918h-.183V130z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.912 133.963h.183v-1.92h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.912 137.925h.183v-1.92h-.183v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.489 126.038h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.196 124.835h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.773 112.947h.184v-1.919h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.773 116.91h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.773 120.871h.184v-1.919h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.643 114.151h.184v-1.919h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.643 118.114h.184v-1.92h-.184v1.92z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.505 122.98H56.154l14.216-20.847h.135v20.847zm-16.237-4.28c0 .946-.157 1.856-.441 2.709v-1.251h-.183v1.75a8.613 8.613 0 01-1.687 2.644v-1.636h-.183v1.829a8.631 8.631 0 01-1.524 1.22v-1.845h-.183v1.92h.069c-.57.347-1.185.63-1.832.838h-.108v.035a8.55 8.55 0 01-2.52.378h-.873v-.413h-.184v.413h-.115v-3.675h.115v1.22h.184v-1.22h.874a4.92 4.92 0 004.39-2.716v1.178h.183v-1.588a4.89 4.89 0 00.343-1.791v-10.44a1.84 1.84 0 011.837-1.838 1.84 1.84 0 011.838 1.838v10.44zm-10.41 3.449h-.013v6.34h.014v11.398h-2.634v-1.123h-.183v1.123h-3.394v-1.123h-.184v1.123H35.15V113.81h-.001V81.975a4.356 4.356 0 014.184-4.346v1.022h.184v-1.03a4.359 4.359 0 014.34 4.354v40.173zm-9.368-8.339h-2.127v-1.578h-.183v1.578h-2.435c-.324 0-.644-.018-.96-.051v-1.527h-.182v1.504a9.026 9.026 0 01-3.03-.944v-.56h-.182v.465a9.132 9.132 0 01-1.687-1.193v-.476h-.184v.307a9.146 9.146 0 01-1.524-1.868v-1.04h-.183v.726a9.023 9.023 0 01-1.158-4.432V88.345c0-.858.466-1.607 1.158-2.013v.244h.183v-.341c.302-.144.639-.226.995-.226a2.339 2.339 0 012.336 2.336v16.377c0 .243.025.48.063.713v.95h.183v-.221a4.427 4.427 0 001.525 2.086v.894h.182v-.758a4.4 4.4 0 001.322.598v1.365h.183v-1.319c.309.069.629.108.959.108h.565v.005h.183v-.005h1.687v1.21h.183v-1.21h2.127v4.672zm49.418 15.262v-6.092h-6.092V92.926h-7.311l-15.546 21.816-.036-6.483a2.493 2.493 0 10-4.986 0v10.44a4.265 4.265 0 01-4.26 4.26h-1.163V81.975a5.01 5.01 0 00-10.02 0v26.235h-.004v.273h-4.745a3.765 3.765 0 01-3.761-3.761V88.345a2.992 2.992 0 10-5.984 0v16.377c0 5.373 4.37 9.744 9.745 9.744h4.745v.084h.005v25.992h5.177v.017h2.979v-.017h1.863v-12.597h1.163c1.56 0 3.127-.351 4.52-.993v2.12h20.308v11.159h-1.04v.328h6.624v-.328h1.727v-11.158h6.092z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.783 140.56h5.959v-.329h-5.959v.329z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.846 140.56h2.979v-.329h-2.979v.329z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.722 140.56H180v-.329h-3.278v.329z",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.756 113.284c.11 0 .2-.095.2-.211a.21.21 0 00-.098-.176.194.194 0 00-.102-.034c-.11 0-.2.094-.2.21 0 .06.023.113.06.15.037.038.086.06.14.06",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.923 114.967c.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21-.11 0-.2.093-.2.21 0 .115.09.21.2.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.588 114.967c.11 0 .2-.095.2-.21a.205.205 0 00-.2-.21c-.11 0-.2.093-.2.21 0 .115.09.21.2.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.254 114.967c.11 0 .199-.095.199-.21a.205.205 0 00-.2-.21c-.11 0-.2.093-.2.21 0 .115.09.21.2.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.09 116.931c.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21-.11 0-.2.093-.2.21 0 .115.09.21.2.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.756 116.931c.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21-.11 0-.2.093-.2.21 0 .115.09.21.2.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.42 116.931c.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21-.11 0-.2.093-.2.21 0 .115.09.21.2.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.923 118.615c.11 0 .2-.095.2-.211 0-.116-.09-.21-.2-.21-.11 0-.2.094-.2.21 0 .116.09.21.2.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.588 118.615c.11 0 .2-.095.2-.211a.205.205 0 00-.2-.21c-.11 0-.2.094-.2.21 0 .116.09.21.2.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.254 118.615c.11 0 .199-.095.199-.211a.205.205 0 00-.2-.21c-.11 0-.2.094-.2.21 0 .116.09.21.2.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.756 120.579c.11 0 .2-.095.2-.211 0-.116-.09-.21-.2-.21-.11 0-.2.094-.2.21 0 .116.09.21.2.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.42 120.579c.11 0 .2-.095.2-.211 0-.116-.09-.21-.2-.21-.11 0-.2.094-.2.21 0 .116.09.21.2.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.082 123.805c-.111 0-.2.094-.2.21 0 .116.089.211.2.211.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.082 120.158c-.111 0-.2.094-.2.21 0 .116.089.21.2.21.11 0 .2-.094.2-.21 0-.116-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.249 122.262c.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21-.11 0-.2.093-.2.21 0 .115.09.21.2.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.914 121.841c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.42 109.636c.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21-.11 0-.2.093-.2.21 0 .115.09.21.2.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.086 109.215c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.588 111.32c.11 0 .2-.095.2-.211a.205.205 0 00-.2-.21c-.11 0-.2.094-.2.21 0 .116.09.21.2.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.254 110.899c-.111 0-.2.094-.2.21 0 .116.089.21.2.21.11 0 .199-.094.199-.21a.205.205 0 00-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.09 131.1c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.919 121.841c-.111 0-.2.094-.2.21 0 .116.089.211.2.211.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.756 123.805c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.42 123.805c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.086 123.805c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.75 123.805c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.923 125.489c-.11 0-.2.094-.2.21 0 .116.09.21.2.21.11 0 .2-.094.2-.21 0-.116-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.588 125.489c-.11 0-.2.094-.2.21 0 .116.09.21.2.21.11 0 .2-.094.2-.21a.205.205 0 00-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.254 125.489c-.111 0-.2.094-.2.21 0 .116.089.21.2.21.11 0 .199-.094.199-.21a.205.205 0 00-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.919 125.489c-.111 0-.2.094-.2.21 0 .116.089.21.2.21.11 0 .2-.094.2-.21 0-.116-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.584 125.489c-.11 0-.2.094-.2.21 0 .116.09.21.2.21.11 0 .2-.094.2-.21 0-.116-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.756 127.453c-.11 0-.2.094-.2.21 0 .116.09.21.2.21.11 0 .2-.094.2-.21 0-.116-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.42 127.453c-.11 0-.2.094-.2.21 0 .116.09.21.2.21.11 0 .2-.094.2-.21 0-.116-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.086 127.453c-.11 0-.2.094-.2.21 0 .116.09.21.2.21.11 0 .2-.094.2-.21 0-.116-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.75 127.453c-.11 0-.2.094-.2.21 0 .116.09.21.2.21.11 0 .2-.094.2-.21 0-.116-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.416 127.453c-.11 0-.2.094-.2.21 0 .116.09.21.2.21.11 0 .2-.094.2-.21a.205.205 0 00-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.923 129.136c-.11 0-.2.094-.2.21 0 .116.09.211.2.211a.202.202 0 00.184-.127v-.004a.237.237 0 00.016-.08c0-.116-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.588 129.136c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.21a.205.205 0 00-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.254 129.136c-.111 0-.2.094-.2.21 0 .116.089.211.2.211.11 0 .199-.095.199-.21a.205.205 0 00-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.919 129.136c-.111 0-.2.094-.2.21 0 .116.089.211.2.211.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.584 129.136c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.249 129.136c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.756 131.1c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.42 131.1c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.086 131.1c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.75 131.1c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.416 131.1c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.21a.205.205 0 00-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.923 132.784c-.11 0-.2.094-.2.21 0 .116.09.21.2.21.11 0 .2-.094.2-.21 0-.116-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.588 132.784c-.11 0-.2.094-.2.21 0 .116.09.21.2.21.11 0 .2-.094.2-.21a.205.205 0 00-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.254 132.784c-.111 0-.2.094-.2.21 0 .116.089.21.2.21.11 0 .199-.094.199-.21a.205.205 0 00-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.919 132.784c-.111 0-.2.094-.2.21 0 .116.089.21.2.21.11 0 .2-.094.2-.21 0-.116-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.584 132.784c-.11 0-.2.094-.2.21 0 .116.09.21.2.21.11 0 .2-.094.2-.21 0-.116-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.249 132.784c-.11 0-.2.094-.2.21 0 .116.09.21.2.21.11 0 .2-.094.2-.21 0-.116-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.756 134.748c-.11 0-.2.093-.2.21 0 .115.09.21.2.21.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.42 134.748c-.11 0-.2.093-.2.21 0 .115.09.21.2.21.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.086 134.748c-.11 0-.2.093-.2.21 0 .115.09.21.2.21.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.75 134.748c-.11 0-.2.093-.2.21 0 .115.09.21.2.21.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.416 134.748c-.11 0-.2.093-.2.21 0 .115.09.21.2.21.11 0 .2-.095.2-.21a.205.205 0 00-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.588 136.431c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.21a.205.205 0 00-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.254 136.431c-.111 0-.2.094-.2.21 0 .116.089.211.2.211.11 0 .199-.095.199-.21a.205.205 0 00-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.919 136.431c-.111 0-.2.094-.2.21 0 .116.089.211.2.211.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.584 136.431c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.42 138.395c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.211 0-.116-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.086 138.395c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.211 0-.116-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.75 138.395c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.211 0-.116-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.254 121.841c-.111 0-.2.094-.2.21 0 .043.014.081.036.114a.192.192 0 00.107.085c.019.005.036.012.057.012.11 0 .199-.095.199-.21a.205.205 0 00-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.76 127.453c-.11 0-.2.094-.2.21 0 .116.09.21.2.21.11 0 .2-.094.2-.21 0-.116-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.425 127.453c-.11 0-.2.094-.2.21 0 .116.09.21.2.21.11 0 .2-.094.2-.21a.205.205 0 00-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.593 129.136c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.258 129.136c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.21 0-.117-.09-.21-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.425 131.1c-.11 0-.2.094-.2.21 0 .116.09.211.2.211.11 0 .2-.095.2-.21a.205.205 0 00-.2-.21",
    fill: "#384AD3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.76 131.1c-.11 0-.2.094-.2.21 0 .066.03.122.075.161a4.74 4.74 0 01-.397.377c-.72.601-1.57.951-2.392.988a2.949 2.949 0 01-.483-.017.189.189 0 00-.105-.035c-.017 0-.031.005-.047.01a2.537 2.537 0 01-.283-.067 12.962 12.962 0 00-.064-4.68c.039-.035.075-.07.114-.103.719-.6 1.568-.95 2.39-.989l.144-.002c.727 0 1.342.257 1.74.735.425.508.562 1.213.385 1.983a3.796 3.796 0 01-.734 1.491.199.199 0 00-.143-.062zm-4.446 1.33a11.843 11.843 0 01-.339 1.518c-.025.082-.052.162-.078.244-.06.187-.123.373-.192.554-.032.087-.066.172-.1.258-.074.18-.152.357-.234.53-.033.071-.065.143-.1.212a9.518 9.518 0 01-.377.691.205.205 0 00-.171.204c0 .016.006.03.009.044-1.295 1.993-3.205 3.262-5.338 3.262-3.895 0-7.062-4.209-7.062-9.383 0-.508.032-1.005.09-1.49.093-.77.256-1.51.482-2.206.043-.133.094-.259.142-.388.044-.016.09-.026.135-.044v-.323l.016-.045c.023-.056.05-.109.074-.163a.205.205 0 00.143-.318c.246-.519.53-1.004.845-1.448a.194.194 0 00.157.087c.023 0 .043-.007.064-.014a.21.21 0 10.06-.358c.005-.039.012-.077.016-.117a8.132 8.132 0 01.663-.736c.948-.926 2.076-1.545 3.3-1.747a5.57 5.57 0 01.699-.068c.059-.002.116-.006.176-.006 1.072 0 2.088.324 2.999.897.013.103.094.185.195.185a.193.193 0 00.068-.015 7.285 7.285 0 011.011.854c1.087 1.102 1.922 2.614 2.384 4.36a.204.204 0 00-.16.201c0 .117.089.211.2.211.006 0 .01-.002.017-.003a.19.19 0 00.046-.01 12.364 12.364 0 01.3 2.704c0 .64-.048 1.262-.14 1.865zm-15.262-6.579a.215.215 0 00.062-.152.204.204 0 00-.2-.21.197.197 0 00-.175.115 3.865 3.865 0 01-.981-1.38.205.205 0 00.19-.209c0-.116-.09-.21-.201-.21a.197.197 0 00-.13.053 4.273 4.273 0 01-.113-.395v.001a4.622 4.622 0 01-.086-.483c-.118-.915.052-1.778.434-2.42l-.004.005c.005-.007.009-.016.013-.024l-.01.018.018-.029a.215.215 0 00.067-.102c.016-.024.032-.049.05-.073.302-.418.708-.718 1.193-.833 1.363-.326 2.832.913 3.272 2.761.038.162.065.324.086.485a9.559 9.559 0 00-1.356 1.854 10.979 10.979 0 00-.762 1.648c-.46.02-.93-.123-1.367-.42zm7.84-9.097a.2.2 0 00.194.177c.11 0 .2-.095.2-.21a.205.205 0 00-.2-.21.195.195 0 00-.14.06c.07-.209.15-.418.242-.625a6.896 6.896 0 011.428-2.102l.005-.004a5.642 5.642 0 01.538-.473l.009-.007.003-.002.01-.008c.024-.019.048-.035.072-.053l.066-.048c.03.02.064.035.102.035.11 0 .2-.095.2-.21 0-.009-.004-.017-.005-.026l.017-.01c.002 0 .003 0 .005-.002h-.001c.566-.35 1.166-.574 1.76-.645a3.337 3.337 0 01.719-.012c.329.031.65.112.958.248.323.143.612.342.869.584.008.01.018.017.028.027.503.485.872 1.15 1.063 1.954.267 1.12.166 2.376-.277 3.583a.192.192 0 00-.076-.017c-.11 0-.2.095-.2.211 0 .087.05.161.122.193l-.022.053c-.14.32-.303.622-.482.91a.224.224 0 00-.077-.016c-.111 0-.2.094-.2.21 0 .053.02.101.052.138-.54.763-1.21 1.384-1.964 1.8-.041.023-.082.04-.123.061-1.248-1.129-2.761-1.794-4.393-1.794-.064 0-.126.007-.19.01a.21.21 0 00.082-.166.204.204 0 00-.2-.21c-.11 0-.2.093-.2.21 0 .075.039.137.095.174l-.066.003c-.411-1.083-.436-2.436-.022-3.79zm.154-5.546c-.643-1.64-.183-3.36 1.025-3.835h.002a.24.24 0 00-.02.088c0 .117.09.211.2.211.11 0 .2-.094.2-.21a.21.21 0 00-.09-.172c.117-.024.236-.038.358-.038.393 0 .804.123 1.2.365.654.398 1.19 1.063 1.507 1.873.304.772.359 1.562.21 2.231-1.08.05-2.177.526-3.124 1.338-.608-.383-1.146-1.03-1.468-1.85zm-19.268 11.773h-14.351l14.215-20.849h.136v20.85zm32.499 6.837c.12-.53.118-1.04.003-1.503a.904.904 0 00-.032-1.807.9.9 0 00-.786.466c-.547-.473-1.283-.71-2.122-.674-.913.041-1.844.408-2.642 1.032-.47-1.79-1.316-3.356-2.418-4.533 1.232-.696 2.26-1.87 2.902-3.319.648-1.468.823-3.045.49-4.44-.341-1.428-1.17-2.499-2.332-3.013a3.662 3.662 0 00-1.042-.28c.148-.77.074-1.645-.26-2.498-.37-.942-1-1.72-1.775-2.192-.576-.35-1.182-.5-1.76-.448a.897.897 0 00-.783-1.35.905.905 0 00-.337 1.743c-1.21.805-1.642 2.674-.947 4.446.349.891.927 1.606 1.595 2.07a7.529 7.529 0 00-1.444 2.162c-.758 1.715-.831 3.517-.335 4.955-1.15.223-2.22.777-3.145 1.585-.007-.029-.011-.058-.018-.088-.524-2.199-2.347-3.656-4.062-3.248-.09.022-.174.05-.258.08a.904.904 0 10-1.207.878c-.628.78-.938 1.922-.803 3.14h-1.671V92.925h-7.31l-20.308 28.499v7.65h20.308v11.236h-.01v.25h8.435v-.25h-1.115v-11.237h4.682c-.057.487-.094.983-.094 1.491 0 5.535 3.462 10.04 7.718 10.04 3.505 0 6.47-3.059 7.406-7.23a3.293 3.293 0 001.076.118c.965-.044 1.953-.449 2.78-1.14.83-.692 1.405-1.592 1.62-2.534z",
    fill: "#384AD3",
    "data-color": 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.df2792b1b12ac7f32536222a0ef9486c.svg";
export { ForwardRef as ReactComponent };